<script>
  import { mergeData } from 'vue-functional-data-merge'
  import { getScopedStyleData } from '~/utils/dom'

  export default {
    name: 'Card',
    functional: true,
    render (h, { data, parent, props, slots }) {
      const children = slots()
      const styleData = getScopedStyleData(parent)

      const renderHeader = () => h('header', { staticClass: 'card__header' }, children.header)
      const renderContent = () => h('div', { staticClass: 'card__inner' }, [children.default])

      const componentData = {
        staticClass: 'card',
      }

      return h(props.tag, mergeData(data, styleData, componentData), [
        children.header ? renderHeader() : false,
        renderContent(),
      ])
    },
    props: {
      tag: {
        type: String,
        default: 'div',
      },
    },
  }
</script>
